// Module
var code = `<template class="dyn-table" contextmenu.trigger="onContextMenu(\$event)">
  <require from="./dyn-table.scss"></require>
  <style>\${columnStyleCss}</style>
  <slot></slot>
  <mdc-menu view-model.ref="columnMenu" hoist-to-body quick-open stay-open-on-selection>
    <mdc-list>
      <mdc-list-item if.bind="renameTarget" click.delegate="startRename()">
        <span class="dyn-table__column-toggle-check" aria-hidden="true"></span>Rename column
      </mdc-list-item>
      <mdc-list-item repeat.for="column of hideableColumns" click.delegate="toggleColumn(column.key)">
        <span class="dyn-table__column-toggle-check" aria-hidden="true">\${column.visible ? '✓' : ''}</span>\${column.label}
      </mdc-list-item>
      <mdc-list-item click.delegate="resetColumns()">Reset columns</mdc-list-item>
    </mdc-list>
  </mdc-menu>
</template>
`;
// Exports
export default code;